import { useSearchParameters } from '@/components/signup/hooks/use-search-parameters';

export type TipsViewType = 'default' | 'jira-bundle' | 'jira-only-bundle';

export function useTipsViewType() {
	const { products } = useSearchParameters();
	const { length: jiraProductsCount } = products.filter((product) => product.includes('jira'));
	const nonJiraProductsCount = products.length - jiraProductsCount;
	if (jiraProductsCount >= 2 && nonJiraProductsCount > 0) {
		return 'jira_bundle';
	} else if (jiraProductsCount >= 2 && nonJiraProductsCount === 0) {
		return 'jira_only_bundle';
	} else {
		return 'default';
	}
}
